const { SvgIcon } = require("@mui/material");

function DeleteFile(props) {
  return (
    <SvgIcon
      sx={{
        fill: "none",
        "& g": {
          stroke: (theme) => theme.palette.text.primary,
        },
      }}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.6409 20.9874C18.9967 20.9874 20.9738 19.0094 20.9738 15.6546L21 10.9989C21 7.57609 19.7584 5.86421 16.3948 5.86421H13.7415C13.0682 5.86227 12.4348 5.54554 12.0296 5.00827L11.1737 3.86961C10.7695 3.33137 10.1361 3.01367 9.46278 3.01367H7.58768C4.23193 3.01367 3 4.99079 3 8.34168V15.6546C3 19.0094 4.981 20.9874 8.34452 20.9874H15.6409Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7892 14.9845L10.209 11.4043M10.2099 14.9854L13.7901 11.4052"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default DeleteFile;
